/** One tick of the game (docs/spec/02 §1). */

import { updateBeam, updateRescue } from './beam';
import { updateDirector } from './director';
import { updateEmpress } from './empress';
import { updateEnemies } from './enemy';
import { updateFlow } from './flow';
import { updateFormation } from './formation';
import { updatePlayer } from './player';
import { tickPowers, updateCapsules } from './powerups';
import { tickChain } from './score';
import { collide, updateBombs, updateShots } from './shots';
import { updateSpawner } from './spawn';
import { difficulty, FLOW, heat } from './tuning';
import type { GameState, Input } from './types';
import { NO_INPUT } from './types';

/**
 * Advance the game by one tick with what the player is holding. Events for the tick replace the
 * previous tick's. After a game is over the hive flies on for a few seconds and then all is still.
 */
export function step(s: GameState, input: Input): void {
  s.events.length = 0;
  const over = s.phase === 'gameover';
  if (over && s.phaseT >= FLOW.gameOverTicks) return;
  s.tick++;
  if (s.capturedMsg > 0) s.capturedMsg--;
  updateFlow(s);
  const d = difficulty(heat(s.mode, s.stage));
  // Chrono: the hive, its bombs and the Empress move every other tick (03 §2).
  const held = s.powers.chrono > 0 && s.tick % 2 === 1;
  if (!held) {
    updateFormation(s);
    updateSpawner(s, d);
    updateDirector(s, d);
    updateEnemies(s, d);
    updateBeam(s);
    updateEmpress(s, d);
    updateBombs(s);
  }
  updateRescue(s);
  updatePlayer(s, over ? NO_INPUT : input);
  updateShots(s);
  updateCapsules(s);
  collide(s);
  tickPowers(s);
  tickChain(s);
  if (s.enemies.some((e) => e.gone)) s.enemies = s.enemies.filter((e) => !e.gone);
}
